<div class="search">
	<ansyn-search-panel></ansyn-search-panel>
	<ansyn-filters-panel></ansyn-filters-panel>
</div>
<ansyn-display-panel></ansyn-display-panel>
<ansyn-case-panel></ansyn-case-panel>